import { render } from "./ProjectCard.vue?vue&type=template&id=392e6ac0&scoped=true&ts=true"
import script from "./ProjectCard.vue?vue&type=script&lang=ts"
export * from "./ProjectCard.vue?vue&type=script&lang=ts"

import "./ProjectCard.vue?vue&type=style&index=0&id=392e6ac0&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-392e6ac0"]])

export default __exports__